<template>
    <Former
        :action="submit"
        :buttonLabel="$t('external.reset_password.send')"
    >
        <div v-if="success" class="reset-password__success">
            {{ $t('external.reset_password.success') }}
        </div>

        <form-input
            v-model="email"
            ref="emailRef"
            validators="required"
            :label="`${ $t('external.reset_password.title') }*`"
        />
    </Former>
</template>

<script lang="ts">
    import { defineComponent, ref, reactive, toRefs } from 'vue'
    import { forgotPassword } from '@services/auth/authDataService'
    import useValidate        from '@composables/useValidate'
    import Former             from '@components/form/Former.vue'
    import formInput          from '@components/form/formInput.vue'

    export default defineComponent({
        components: {
            Former,
            formInput
        },
        setup() {
            const emailRef = ref<HTMLFormElement | null>(null)

            const state = reactive({
                success: false,
                email: ''
            })

            const submit = () => {
                let refsToValidate = {
                    'emailRef': emailRef.value
                }

                const hasError = useValidate(refsToValidate)

                if (!hasError) {
                    forgotPassword({ email: state.email }).then(response => {
                        state.success = response.status === 'Success'

                        setTimeout(() => {
                            state.success = false
                        }, 3000)
                    })
                }
            }

            return {
                emailRef,
                ...toRefs(state),
                submit
            }
        }
    })
</script>
